<template>
    <router-link :to="`/blog/post/${id}`" class="blog-card" :class="{'no-border': false}">
        <div class="blog-card__img" >
            <lazy-image :image="img" width="100%"
            height="100%"/>
            <div v-if="sidebar">
                <span class="sticker">{{offset + 1}}</span>
            </div>
            <span class="blog-card__img__flag"
                  :style="{backgroundColor: flag}">
                {{catTitle}}
            </span>
        </div>
        <div class="blog-card__content">
            <h3 class="blog-card__content__title">{{title}}</h3>
            <vue-markdown class="blog-card__content__desc" :source="desc"></vue-markdown>
        </div>
    </router-link>
</template>

<script>
    import VueMarkdown from 'vue-markdown';
    import LazyImage from "./LazyImage";

    export default {
        name: "BlogCard",
        props: [ 'catTitle', 'img', 'title', 'desc', 'flag', 'footer', 'id', 'sidebar', 'offset'],
        data() {
            return {
                whatFlag: '',
            }
        },
        mounted() {
        },
        components: {
            VueMarkdown,
            LazyImage
        }
    }
</script>

<style lang="scss" scoped>
    .blog-card {
        width: 270px;
        height: 360px;
        display: block;
        border: 1px solid #e5e5e5;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;

        &__img {
            position: relative;
            height: 180px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;

            &__flag {
                color: #fff;
                position: absolute;
                padding: 5px 10px;
                bottom: -15px;
                left: 30px;
                width: auto;
                text-align: center;
                font-size: 0.875rem;
                font-family: "Open Sans";
                font-weight: 600;
            }
        }

        &__content {
            padding: 30px 20px 33px 20px;
            background: #fff;

            &__title {
                font-size: 1.125rem;
                font-family: "Open Sans";
                color: #0a0a0a;
                height: 48px;
                overflow: hidden;
            }

            &__desc {
                margin-top: 10px;
                height: 55px;
                overflow: hidden;
                color: #666666;
                font-family: "Open Sans";
                font-size: 0.875rem;
                font-weight: 500;
                padding-right: 8px;

                &:hover {
                    overflow: auto;
                }
            }
        }
    }

    .sticker {
        position: absolute;
        top: -18px;
        left: 20px;
        width: 40px;
        height: 40px;
        color: #fff;
        background: #1d1d1d;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        font-size: 1rem;
        font-family: "Open Sans";
    }

    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #aaa;
        border-radius: 20px;

    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    @media only screen and (max-width: 1024px) {
        .blog-card__content__desc {
            overflow: auto;
        }

        .blog-card {
            margin: 0 auto;
        }
    }

    .no-border {
        border: none !important;
    }
</style>